<template>
  <div class="surrender-success">
    <div class="title">您的退保登记已提交，请等待操作</div>
    <img src="../../assets/img/404/404.png" alt="" />
  </div>
</template>
<script>
  export default {
    data() {
      return {}
    }
  }
</script>
<style lang="scss" scoped>
  .surrender-success {
    .title {
      font-size: xvw(30);
      font-weight: 600;
      text-align: center;
      margin: xvw(100);
    }
    img {
      display: block;
      width: 80%;
      margin: 0 auto;
    }
  }
</style>
